import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { AboutUsComponent } from "@component/peripherals/about-us/about-us.component";
import { AgbComponent } from "@component/peripherals/agb/agb.component";
import { CareerComponent } from "@component/peripherals/career/career.component";
import { ContactComponent } from "@component/peripherals/contact/contact.component";
import { ImpressumComponent } from "@component/peripherals/impressum/impressum.component";
import { PrivacyComponent } from "@component/peripherals/privacy/privacy.component";
import { SharedModule } from "./shared.module";

@NgModule({
  declarations: [
  ],
  imports: [
    SharedModule,
    RouterModule.forChild([
      {
        path: "about",
        component: AboutUsComponent
      },
      {
        path: "contact",
        component: ContactComponent
      },
      {
        path: "career",
        component: CareerComponent
      },
      {
        path: "agb",
        component: AgbComponent
      },
      {
        path: "privacy",
        component: PrivacyComponent
      },
      {
        path: "impressum",
        component: ImpressumComponent
      },
    ]),
  ],
  exports: [
    SharedModule,
  ]
})
export class PeripheralModule { }